export const SYSTEM_DEFAULT_START_TIME = "09:00";
export const SYSTEM_DEFAULT_END_TIME = "18:00";

export const MAX_SERVICE_PRICE_NIS = 20000;

export const INVALID_EMAIL_MARK = "[invalid]";

export const CALENDAR_MIN_VIEW_IN_MONTHS = 4;
export const CALENDAR_MAX_VIEW_IN_MONTHS = 8;
